import KullanicilarService from "@/services/KullanicilarService";
export default {
  namespaced: true,
  state: () => ({
    kullaniciListesi: [],
    kullaniciSayisi: 0,
    kullaniciDetay: {},
  }),
  mutations: {
    setKullaniciListesi: (state, data) => {
      state.kullaniciListesi = data;
    },
    setKullaniciSayisi: (state, data) => {
      state.kullaniciSayisi = data;
    },
    setKullaniciDetay: (state, data) => {
      state.kullaniciDetay = data;
    },
  },
  actions: {
    kullaniciListesi: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        KullanicilarService.kullaniciListesi(data)
          .then((res) => {
            commit("setKullaniciListesi", res.data.list);
            commit("setKullaniciSayisi", parseInt(res.data.count));
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    kullaniciAra: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        KullanicilarService.kullaniciAra(data)
          .then((res) => {
            if (res.data !== null) {
              commit("setKullaniciListesi", res.data.list);
              commit("setKullaniciSayisi", parseInt(res.data.count));
            } else {
              commit("setKullaniciListesi", ["0"]);
              commit("setKullaniciSayisi", 0);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // kullaniciSayisi: ({ commit }) => {
    //   return new Promise((resolve, reject) => {
    //     KullanicilarService.kullaniciSayisi()
    //       .then((res) => {
    //         commit("setKullaniciSayisi", res.data);
    //         resolve(res);
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
    kullaniciEkle: ({ dispatch }, kullaniciData) => {
      return new Promise((resolve, reject) => {
        KullanicilarService.kullaniciEkle(kullaniciData)
          .then((res) => {
            dispatch("kullaniciListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    kullaniciDetay: ({ commit }, kullaniciID) => {
      return new Promise((resolve, reject) => {
        KullanicilarService.kullaniciDetay(kullaniciID)
          .then((res) => {
            commit("setKullaniciDetay", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
